import { jsx as o } from "react/jsx-runtime";
import { c } from "../../../index-Cu0xwYjD.js";
import '../../../assets/P.css';const f = "_text_wfgf1_3", i = "_inverted_wfgf1_12", t = {
  text: f,
  inverted: i
}, _ = ({
  children: e,
  inverted: s,
  className: r,
  ...n
}) => /* @__PURE__ */ o(
  "p",
  {
    className: c(
      t.text,
      {
        [t.inverted]: s
      },
      r
    ),
    ...n,
    children: e
  }
);
export {
  _ as P
};
